const breadCrumb = "Lançamento de Notas - Lançamento de Notas/Conceitos/Faltas";

const routes = [
  {
    path: "/consultar-resumo-de-lancamento-de-notas-conceitos",
    name: "consultar-resumo-de-lancamento-de-notas-conceitos",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultarResumoDeLancamentoDeNotasConceitos/ConsultarResumoDeLancamentoDeNotasConceitosHome.vue"
      ),
  },
];

export default routes;
